'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('styled-components');
var fontFace = require('./font-face.js');
var reset = require('./reset.js');

const globalComponentCss = styled.css`
  body.dialog-open {
    overflow: hidden;
  }
`;
/**
 * All Brandfolder global styles (reset, Circular font, and icon font)
 */ const BrandfolderGlobalStyles = styled.createGlobalStyle`
  ${reset.cssReset}
  ${fontFace.circularFonts}
  ${fontFace.iconFont}
  ${globalComponentCss}
`;
/**
 * Brandfolder global reset
 */ const BrandfolderGlobalReset = styled.createGlobalStyle`
  ${reset.cssReset}
`;
/**
 * Brandfolder Circular font
 */ const BrandfolderGlobalCircularFont = styled.createGlobalStyle`
  ${fontFace.circularFonts}
`;
/**
 * Brandfolder icon font
 */ const BrandfolderGlobalIconFont = styled.createGlobalStyle`
  ${fontFace.iconFont}
`;
/**
 * Brandfolder global fonts (Circular font and icon font)
 */ const BrandfolderGlobalFonts = styled.createGlobalStyle`
  ${fontFace.circularFonts}
  ${fontFace.iconFont}
`;
/**
 * Brandfolder global component styles.
 * Required for dialog component.
 */ const BrandfolderGlobalComponentStyles = styled.createGlobalStyle`
  ${globalComponentCss}
`;

exports.BrandfolderGlobalCircularFont = BrandfolderGlobalCircularFont;
exports.BrandfolderGlobalComponentStyles = BrandfolderGlobalComponentStyles;
exports.BrandfolderGlobalFonts = BrandfolderGlobalFonts;
exports.BrandfolderGlobalIconFont = BrandfolderGlobalIconFont;
exports.BrandfolderGlobalReset = BrandfolderGlobalReset;
exports.BrandfolderGlobalStyles = BrandfolderGlobalStyles;
//# sourceMappingURL=global.js.map
